module.exports = __webpack_public_path__ + "static/media/apple_btn.c7fdbb3e.png";